const initialState = {
    main: '',
    loader_main:false,
};
const main = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_BASE_MAIN_SITE':
            return {...state, main:  action.main};
        case "CHANGE_DATA_MAIN_SITE":
            return {...state,[action.name]:action.value}
        default:
            return state;
    }
};

export default main;